import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from '../../../../libraries/language';
import { IPilot } from '../../../../models/pilot.model';
import style from './pilots-list.module.scss';
import PilotsAdd from '../pilots-add/pilots-add.component';
import PilotsEdit from '../pilots-edit/pilots-edit.component';
import PilotsDelete from '../pilots-delete/pilots-delete.component';

type IProp = {
  data: IPilot[];
  loading: boolean;
};

const PilotsView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IPilot>[] = [
    {
      title: Lang.LBL_PILOT_NAME,
      index: 'name',
      width: '43%',
    },
    {
      title: Lang.LBL_PILOT_PHONE,
      index: 'phone',
      width: '42%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <PilotsEdit data={value} />
          <PilotsDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IPilot, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_PILOTS} />
        <PilotsAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default PilotsView;
